import React from "react";
import { SvgIcon } from "@material-ui/core";

const BookIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 55.467 42.569">
      <g id="Group_522" data-name="Group 522">
        <path
          id="Path_2239"
          data-name="Path 2239"
          d="M62.286,70h-3.1V80.965a.645.645,0,0,1-1,.537L54.675,79.16,51.163,81.5a.645.645,0,0,1-1-.537V70H45v42.569H72.089V79.8A9.815,9.815,0,0,0,62.286,70ZM49.515,86.769h9.03a.645.645,0,1,1,0,1.29h-9.03a.645.645,0,1,1,0-1.29Zm0,5.16h11.61a.645.645,0,1,1,0,1.29H49.515a.645.645,0,1,1,0-1.29ZM67.575,108.7h-7.74a.645.645,0,1,1,0-1.29h7.74a.645.645,0,1,1,0,1.29Zm0-5.16H49.515a.645.645,0,1,1,0-1.29h18.06a.645.645,0,0,1,0,1.29Zm0-5.16H49.515a.645.645,0,1,1,0-1.29h18.06a.645.645,0,0,1,0,1.29Zm0-19.349h-5.16a.645.645,0,1,1,0-1.29h5.16a.645.645,0,0,1,0,1.29Z"
          transform="translate(-45 -70)"
        />
        <path
          id="Path_2240"
          data-name="Path 2240"
          d="M274.8,70a9.815,9.815,0,0,0-9.8,9.8v32.765h27.089V70Zm2.451,38.7h-7.74a.645.645,0,1,1,0-1.29h7.74a.645.645,0,1,1,0,1.29Zm10.32-5.16h-18.06a.645.645,0,1,1,0-1.29h18.06a.645.645,0,1,1,0,1.29Zm0-5.16h-18.06a.645.645,0,1,1,0-1.29h18.06a.645.645,0,1,1,0,1.29Zm0-5.16h-11.61a.645.645,0,0,1,0-1.29h11.61a.645.645,0,1,1,0,1.29Zm0-5.16h-15.48a.645.645,0,0,1,0-1.29h15.48a.645.645,0,1,1,0,1.29Z"
          transform="translate(-236.622 -70)"
        />
      </g>
    </SvgIcon>
  );
};

export default BookIcon;
